module.exports = __webpack_public_path__ + "img/authenticate1.e02a3d7e.jpg";